import * as Auth from 'aws-amplify/auth';
import { authServiceFactory } from '@whistler-ui/k2/factories';
import i18next from 'i18next';

export const AuthService = authServiceFactory({ Auth, i18n: i18next });
